module.exports = __webpack_public_path__ + "static/media/gator-modal-slide-1.1084b860.png";